import { render, staticRenderFns } from "./categorize.vue?vue&type=template&id=433e7f2a&scoped=true&"
import script from "./categorize.vue?vue&type=script&lang=js&"
export * from "./categorize.vue?vue&type=script&lang=js&"
import style0 from "./categorize.vue?vue&type=style&index=0&id=433e7f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433e7f2a",
  null
  
)

export default component.exports